import { Globe } from 'lucide-react';
import { useEffect, useState } from 'react';
import { cn } from '@/Domain/utils/cn';
import { faviconUrl } from '@/Domain/utils/favicon';

interface FaviconProps {
  url: string;
  className?: string;
}

export const Favicon = ({ url, className }: FaviconProps) => {
  const src = faviconUrl(url);
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [url]);

  if (!src || failed) {
    return <Globe className={cn('text-muted-foreground', className)} aria-hidden />;
  }

  return (
    <img
      src={src}
      alt=""
      className={cn('object-contain', className)}
      onError={() => setFailed(true)}
    />
  );
};
